<p-table [scrollable]="true" [size]="'small'" [value]="this.contacts()" scrollHeight="flex">
  <ng-template #header>
    <tr>
      <th pResizableColumn pSortableColumn="firstName">{{ 'user.first-name' | translate }}
        <p-sortIcon field="firstName"/>
      </th>
      <th pResizableColumn pSortableColumn="lastName">{{ 'user.last-name' | translate }}
        <p-sortIcon field="lastName"/>
      </th>
      <th pResizableColumn pSortableColumn="email">{{ 'user.email' | translate }}
        <p-sortIcon field="email"/>
      </th>
      <th pResizableColumn pSortableColumn="phone">{{ 'customer.phone' | translate }}
        <p-sortIcon field="phone"/>
      </th>
      <th pResizableColumn pSortableColumn="companyName">{{ 'entity.company' | translate }}
        <p-sortIcon field="companyName"/>
      </th>
      <th></th>
    </tr>
  </ng-template>

  <ng-template #body let-contact>
    <tr (click)="onRowSelect(contact)" class="cursor-pointer hover:bg-gray-50">
      <td>
        {{ contact.firstName }}
        @if (!contact.isActive) {
          <span
            class="ml-2 px-2 py-0.5 text-xs rounded bg-gray-200 text-gray-600">{{ 'customer.inactive' | translate }}</span>
        }
      </td>
      <td>{{ contact.lastName }}</td>
      <td>
        @if (contact.email) {
          <a (click)="$event.stopPropagation()" [href]="'mailto:' + contact.email"
             class="hover:underline">{{ contact.email }}</a>
        }
      </td>
      <td>
        @if (contact.phone) {
          <a (click)="$event.stopPropagation()" [href]="'tel:' + contact.phone"
             class="hover:underline">{{ contact.phone }}</a>
        }
      </td>
      <td>{{ contact.companyName }}</td>
      <td class="flex justify-end gap-1">
        <elcia-button (onClick)="delete($event, contact)" [icon]="'delete'" [severity]="'danger'" [variant]="'text'"/>
      </td>
    </tr>
  </ng-template>
</p-table>
